export const isMobile = () => {
    return window.innerWidth < 768;
}

export const getEventUrl = (slugId: string): string => {
    return `https://qa.eventox.co/event/${slugId}`;
}